var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template-container" }, [
    _c("div", { staticClass: "card m-0" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "input-group" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.requestLogin,
                expression: "requestLogin",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Поиск ...",
              "aria-describedby": "btnGroupAddon",
            },
            domProps: { value: _vm.requestLogin },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.requestLogin = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("iframe", {
      attrs: {
        id: "iFrame",
        src: "https://crypto.com/price/showroom/biggest-gainers",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body p-1 flex justify-content-around" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-info",
            on: {
              click: function ($event) {
                return _vm.updatePass(0)
              },
            },
          },
          [_vm._v("IDEX")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-info",
            on: {
              click: function ($event) {
                return _vm.updatePass(1)
              },
            },
          },
          [_vm._v("FLOKI")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-info",
            on: {
              click: function ($event) {
                return _vm.updatePass(2)
              },
            },
          },
          [_vm._v("INJ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-info",
            on: {
              click: function ($event) {
                return _vm.updatePass(3)
              },
            },
          },
          [_vm._v("CTSI")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-info",
            on: {
              click: function ($event) {
                return _vm.updatePass(4)
              },
            },
          },
          [_vm._v("RAD")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("div", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "icon-fa icon-fa-search" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }